import React, { useCallback } from 'react';

import { CalculatedLine, Component } from '@paragon/contract-library';

import { useAppDispatch } from '../../components/hooks';
import { finishSetReferenceLineIntersectionGuid } from '../../store/actions/insertActions';
import { PickingReferenceLineIntersectionInfo, ReferenceLineIntersection } from '../../store/slices/applicationSlice';
import { ReferenceLineIntersections } from './ReferenceLineIntersections';

interface Props {
  readonly component: Component;
  readonly visibleReferenceLines: readonly CalculatedLine[];
  readonly pickingInfo: PickingReferenceLineIntersectionInfo;
}

export function PickingReferenceLineIntersectionController({ component, visibleReferenceLines, pickingInfo }: Props) {
  const dispatch = useAppDispatch();

  const onClickIntersection = useCallback(
    (intersection: ReferenceLineIntersection) => {
      dispatch(
        finishSetReferenceLineIntersectionGuid(
          pickingInfo.referenceLineInfo.rootGuid,
          intersection.line1Guid,
          intersection.line2Guid,
        ),
      );
    },
    [dispatch, pickingInfo.referenceLineInfo.rootGuid],
  );

  return (
    <ReferenceLineIntersections
      component={component}
      visibleReferenceLines={visibleReferenceLines}
      onClickIntersection={onClickIntersection}
    />
  );
}
